import apiClient from "./axios"

// ============================
// 🔹 Pre-Order API Services
// ============================

// Get all pre-orders (paginated or filtered)
export const getPreOrders = async (params = {}) => {
  const { data } = await apiClient.get("/pre-orders", { params })
  return data
}

// Get a specific pre-order by ID
export const getPreOrder = async id => {
  const { data } = await apiClient.get(`/pre-orders/${id}`)
  return data
}

// Create a new pre-order
export const createPreOrder = async preOrderData => {
  const { data } = await apiClient.post("/pre-orders", preOrderData)
  return data
}

// Update an existing pre-order
export const editPreOrder = async ({ id, ...preOrderData }) => {
  const { data } = await apiClient.patch(`/pre-orders/${id}`, preOrderData)
  return data
}

// Soft delete a pre-order
export const deletePreOrder = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.delete(`/pre-orders/${resolvedId}`)
  return data
}

// Cancel a pre-order (releases reserved stock)
export const cancelPreOrder = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.post(`/pre-orders/${resolvedId}/cancel`)
  return data
}

// Generate a money receipt from a pre-order deposit
export const createMoneyReceiptFromPreOrder = async ({ id, ...payload }) => {
  const { data } = await apiClient.post(
    `/pre-orders/${id}/create-money-receipt`,
    payload
  )
  return data
}

// Get trashed pre-orders
export const getTrashedPreOrders = async (params = {}) => {
  const { data } = await apiClient.get("/pre-orders/trashed", { params })
  return data
}

// Restore a trashed pre-order
export const restorePreOrder = async id => {
  const { data } = await apiClient.post(`/pre-orders/${id}/restore`)
  return data
}

// Permanently delete a pre-order
export const forceDeletePreOrder = async id => {
  const { data } = await apiClient.delete(`/pre-orders/${id}/force-delete`)
  return data
}
